import React from "react";

//Línea guía de alineación (capa puramente visual, no se guarda en la BD): se agrega como un nodo más de
//React Flow (no seleccionable/arrastrable) mientras se arrastra otro nodo cerca del eje X o Y de algún
//nodo existente, para que se vea claramente con qué se está alineando - ver MapaAlmacenEditor.js/onNodeDrag.
const LineaGuiaCanvas = () => <div style={{ width: "100%", height: "100%", background: "#00BFD6", opacity: 0.6 }} />;

export default LineaGuiaCanvas;
